import styleInject from '../../../../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".c2-data-model-table-column-header:not(:hover) .p-button {\n    visibility: hidden;\n}\n\n.c2-data-model-table-column-header__op .p-overlaypanel-content {\n    background: transparent !important;\n    border: 0 !important;\n    padding: 0 !important;\n}\n";
styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=ColumnHeader.css.js.map
